export default () => {
    const button = document.querySelector('.openVideoBox');
    const popup = document.querySelector('.home-hero__video-wrapper');

    (button && popup) ? openVideo() : false;

    function openVideo() {
        const close = popup.querySelector('.close-popup');
        const cont  = popup.querySelector('.video-inner-box');
        const video = cont.querySelector('video');
        const scrubber = cont.querySelector('.video-line-box .line');
        const scrubberProgress = scrubber.querySelector('.played');
        const controls = cont.querySelector('.controls');
        const buttonPause = controls.querySelector('button');
        const muteBtn = cont.querySelector(".mute-btns .mute");
        const unmuteBtn = cont.querySelector(".mute-btns .unmute");
        const header = document.querySelector(".site_header.non_sticky.animations");
        let videoPlayerInterval;
        let duration;

        muteBtn.addEventListener("click", () => {
            muteBtn.classList.toggle('hide');
            unmuteBtn.classList.toggle('hide');
            video.muted = 'true';
            
        });

        unmuteBtn.addEventListener("click", () => {
            muteBtn.classList.toggle('hide');
            unmuteBtn.classList.toggle('hide');
            video.muted = '';
            
        });

        button.addEventListener('click', () => {
            popup.classList.add('opened');
            video.muted = '';
            header.classList.add("hide");
            playVideo()
        })

        close.addEventListener('click', () => {
            popup.classList.remove('opened');
            video.muted = 'true';
        })

        popup.addEventListener('click', (e) => {
          if (!e.target.closest('.video-inner-box')) {
            popup.classList.remove('opened');
            header.classList.remove("hide");
            video.muted = 'true';
          }
        })

        video.onloadedmetadata = function() {
            duration = this.duration;
            video.pause();
        }

        function playVideo() {
            video.play()

            if (video.currentTime < duration) {
                videoPlayerInterval = setInterval(function() {
                    let amountPlayed = (video.currentTime / duration);
                    scrubberProgress.setAttribute(
                        "style",
                        '-webkit-transform : scaleX(' + amountPlayed + ');-ms-transform: scaleX(' + amountPlayed + ');transform:scaleX(' + amountPlayed + ');'
                    );
                }, 100);
            } else {
                clearInterval(videoPlayerInterval);
            }

            buttonPause.addEventListener('click', () => {
                if (!video.paused) {
                    video.pause();
                    buttonPause.classList.add('paused')
                } else {
                    video.play();
                    buttonPause.classList.remove('paused')
                }
            })
        }
    }

}
